import React, { useMemo } from 'react'
import FoamTreeChart from 'components/visualization/FoamTree'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { WidgetId } from 'features/types'
import { UsageAndAttitudeWidgetType } from '../types'
import { convertToFoamTreeData } from '../utils/convertToFoamTreeData'

interface FoamTreeProps {
  widgetId: WidgetId
}

const FoamTree = ({ widgetId }: FoamTreeProps) => {
  const widgetSetting = useDashboardWidgetSetting<UsageAndAttitudeWidgetType>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)

  const foamTreeDataObject = useMemo(
    () => ({
      groups: convertToFoamTreeData(widgetData, widgetSetting)
    }),
    [widgetData, widgetSetting]
  )

  return (
    <FoamTreeChart
      height="100%"
      dataObject={foamTreeDataObject}
      className="usage-and-attitude-widget"
    />
  )
}

export default FoamTree
